import { useSelector } from 'react-redux';
import { getNameInitials } from 'utils';
import {
  selectAuthAccessToken,
  selectHospitalLogoUrl,
  selectIsLoggedIn,
  selectIsCaregiverPendingApproval,
  selectRefreshToken,
  selectUser,
  selectIsUserDoneIneligible,
} from '../authSlice';

export const useAuthAccessToken = () => useSelector(selectAuthAccessToken);
export const useIsLoggedIn = () => useSelector(selectIsLoggedIn);
export const useHospitalLogoUrl = () => useSelector(selectHospitalLogoUrl);
export const useLoggedInUser = () => useSelector(selectUser);
export const useUserInitials = () => {
  const user = useSelector(selectUser);
  const firstName = user?.first_name ?? '';
  const lastName = user?.last_name ?? '';
  const fullName = `${firstName} ${lastName}`.trim();
  return fullName ? getNameInitials(fullName) : '';
};
export const useIsCaregiverPendingApproval = () => useSelector(selectIsCaregiverPendingApproval);
export const useIsUserDoneIneligible = () => useSelector(selectIsUserDoneIneligible);
export const useRefreshToken = () => useSelector(selectRefreshToken);
